<template>
	<div>
		<div class="sm:hidden">
			<label for="tabs" class="sr-only">Select a tab</label>
			<select
				v-model="activeTab"
				class="block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
			>
				<option v-for="tab in tabs" :value="tab.name">{{ tab.name }}</option>
			</select>
		</div>
		<div class="hidden sm:block">
			<nav class="flex space-x-4" aria-label="Tabs">
				<a
					v-for="tab in tabs"
					:key="tab.name"
					:href="tab.href"
					:class="[
						isActive(tab)
							? 'bg-gray-100 text-gray-700'
							: 'text-gray-500 hover:text-gray-700',
						'px-3 py-2 font-medium text-sm rounded-md',
					]"
					:aria-current="isActive(tab) ? 'page' : undefined"
					v-on:click="activeTab = tab.name"
					>{{ tab.name }}</a
				>
			</nav>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: String,
			required: true,
		},
		tabs: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			activeTab: this.value,
		};
	},
	methods: {
		isActive(tab) {
			return this.activeTab == tab.name;
		},
	},
	watch: {
		activeTab(val) {
			this.$emit("input", val);
			this.$emit("change");
		},
	},
};
</script>
